// Libraries
import Script from 'next/script';

// Customize
import { GA } from '@/constants/config';

export default function GoogleAnalytics() {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA.MEASUREMENT_ID}`}
      />
      <Script id="google-analytics">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
 
          gtag('config', '${GA.MEASUREMENT_ID}');
        `}
      </Script>
    </>
  );
}
